import axios from "../../config/axiosConfig";
import { 
    CREATE_JOURNAL_VOUCHER_MULTY, 
    GET_JOURNAL_VOUCHER_MULTY, 
    GET_JOURNAL_VOUCHER_MULTY_PAGE, 
    JOURNAL_VOUCHER_MULTY_REQUEST,
    DELETE_JOURNAL_VOUCHER_MULTY, 
    UPDATE_JOURNAL_VOUCHER_MULTY,
    JOURNAL_VOUCHER_MULTY_REQUEST_FAILURE, 
    JOURNAL_VOUCHER_MULTY_REQUEST_SUCCESS 
} from "../types";

export const getJournalVoucherMultysWithPagination = (page, limit, include, searchStr, searchCols, where, showTaxJv, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOURNAL_VOUCHER_MULTY_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, showTaxJv, search: searchStr, searchCols, where, addTotal,
        includeAttr: ''
      };
      return axios.get("/journal-voucher-multy/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_JOURNAL_VOUCHER_MULTY_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOURNAL_VOUCHER_MULTY_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOURNAL_VOUCHER_MULTY_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getJournalVoucherMultys = (include) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: JOURNAL_VOUCHER_MULTY_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id, finyearId: auth.finyear?.id, };
            // if (!auth?.company?.Common_Master) {
                params = { ...params, companyId: auth.company?.id }
            // }
            if (include) {
                params = { ...params, include, showTaxJv: true };
            }
            return axios.get('/journal-voucher-multy/get', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_JOURNAL_VOUCHER_MULTY, payload: response.data?.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: JOURNAL_VOUCHER_MULTY_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: JOURNAL_VOUCHER_MULTY_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const getValidatedIncrementedVchNoJournalVoucherMulty = (currentVchNo) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      
      const response = await axios.get("/journal-voucher-multy/get-next-vch-no", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getJournalVoucherMultyById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOURNAL_VOUCHER_MULTY_REQUEST });
    
      return axios.get(`/journal-voucher-multy/get/${id}`).then((response) => {
        dispatch({ type: JOURNAL_VOUCHER_MULTY_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOURNAL_VOUCHER_MULTY_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOURNAL_VOUCHER_MULTY_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getJournalVoucherMultysByRange = (billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to
      };
      
      const response = await axios.get("/journal-voucher-multy/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const createJournalVoucherMulty = (journalVoucherMulty) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: JOURNAL_VOUCHER_MULTY_REQUEST });
            return axios.post('/journal-voucher-multy/add', journalVoucherMulty,
                { params: {
                    userId: auth.user?.id,
                    companyId: auth.company?.id,
                    customerId: auth?.user?.Customer_Id,
                    finyearId: auth?.finyear?.id
                }}).then((response) => {
                    if (response.data) {
                        dispatch({ type: CREATE_JOURNAL_VOUCHER_MULTY, payload: response.data });
                    } else {
                        dispatch({ type: JOURNAL_VOUCHER_MULTY_REQUEST_FAILURE, error: 'Group create failed.' });
                    }
                    return response;
                }).catch((error) => {
                    console.error(error);
                    dispatch({ type: JOURNAL_VOUCHER_MULTY_REQUEST_FAILURE, error: error.message });
                    throw error;
                });
        } catch (error) {
            console.error(error);
            dispatch({ type: JOURNAL_VOUCHER_MULTY_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updateJournalVoucherMulty = (id, data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: JOURNAL_VOUCHER_MULTY_REQUEST });
            return axios.put('/journal-voucher-multy/update', { id, data },
                { params: {
                    userId: auth.user?.id,
                    companyId: data.Company_Id || auth.company?.id,
                    customerId: data.Customer_Id || auth?.user?.Customer_Id,
                    finyearId: data.Finyear_Id || auth?.finyear?.id
                }
            }).then((response) => {
                if (response.data) {
                    dispatch({ type: UPDATE_JOURNAL_VOUCHER_MULTY, payload: { id, data: response.data } });
                } else {
                    dispatch({ type: JOURNAL_VOUCHER_MULTY_REQUEST_FAILURE, error: 'Group update failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: JOURNAL_VOUCHER_MULTY_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: JOURNAL_VOUCHER_MULTY_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const deleteJournalVoucherMulty = (id) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: JOURNAL_VOUCHER_MULTY_REQUEST });
            return axios.delete(`/journal-voucher-multy/delete/${id}`).then((response) => {
                if (response.data) {
                    dispatch({ type: DELETE_JOURNAL_VOUCHER_MULTY, id: id });
                    const include = ['id', 'Vch_No', 'Date', 'Tax_JV_Ref'].join(',');
                    const searchCols = ['Vch_No'].join(',');
                    const { transaction: { journalVoucherMulty: { page, pageSize, search, where, showTaxJv } = {} } } = getState();
                    dispatch(getJournalVoucherMultysWithPagination(page, pageSize, include, search, searchCols, where, showTaxJv, true));
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: JOURNAL_VOUCHER_MULTY_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: JOURNAL_VOUCHER_MULTY_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};
